export const screenShareState = {
  isSharingScreen: false,
  createdQuotes: [],
  editedQuote: null
};
const screenShareReducer = (state = screenShareState, action) => {
  const newState = { ...state };
  switch (action.type) {
    case "setSessionStatus":
      newState.isSharingScreen = action.payload;
      return newState;
    case "saveQuote":
      newState.createdQuotes.push(action.payload);
      return newState;
    case "clearQuotes":
      newState.createdQuotes = [];
      return newState;
    default:
      return state;
  }
};

export default screenShareReducer;
